module.exports = __webpack_public_path__ + "media/images/recording-dot-c4d27a99.png";